/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {NudePreviewPageComponent} from './nude-preview-page.component';


export function previewStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  const providerParams = {
    url: '/preview-creative/?uuid&creativeId&networkId&creativeWidth&creativeHeight&lineItemId&lineItemCode&layoutType&dataLang&previewLanguage',
    views: {
      'content@nude': {
        component: NudePreviewPageComponent
      },
      'title@nude': stateTitleView()
    },
    data: {
      public: true,
      preview: true,
      title: "{{previewData.pageTitle}}"
    }
  };
  states
    .add('nude.preview', providerParams);
  return states.build();
}